(() => {
  document.documentElement.classList.add('js');
  const drawer = document.querySelector('#cartDrawer');
  const overlay = document.querySelector('#cartOverlay');
  const items = document.querySelector('#cartItems');
  const total = document.querySelector('#cartTotal');
  const money = new Intl.NumberFormat(document.documentElement.lang || 'en-DK', { style: 'currency', currency: window.Shopify?.currency?.active || 'DKK' });
  const toast = message => { const el = document.querySelector('#senseiToast'); if (!el) return; el.textContent = message; el.classList.add('show'); clearTimeout(window.senseiToast); window.senseiToast = setTimeout(() => el.classList.remove('show'), 2200); };
  const openCart = () => { drawer?.classList.add('open'); drawer?.setAttribute('aria-hidden', 'false'); if (overlay) overlay.hidden = false; document.body.classList.add('no-scroll'); renderCart(); };
  const closeCart = () => { drawer?.classList.remove('open'); drawer?.setAttribute('aria-hidden', 'true'); if (overlay) overlay.hidden = true; document.body.classList.remove('no-scroll'); };
  const updateCount = count => document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = count; });
  async function getCart() { const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } }); return response.json(); }
  const escapeHtml = value => String(value ?? '').replace(/[&<>'"]/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','\"':'&quot;'}[character]));
  const cartItemMeta = item => {
    const plan = item.selling_plan_allocation?.selling_plan?.name;
    const properties = Object.entries(item.properties || {})
      .filter(([key, value]) => key && !key.startsWith('_') && value)
      .map(([key, value]) => `<span><b>${escapeHtml(key)}:</b> ${escapeHtml(value)}</span>`);
    if (plan) properties.unshift(`<span><b>Plan:</b> ${escapeHtml(plan)}</span>`);
    return properties.length ? `<div class="cart-subscription-meta">${properties.join('')}</div>` : '';
  };
  async function renderCart() { if (!items) return; const cart = await getCart(); updateCount(cart.item_count); items.innerHTML = cart.items.length ? cart.items.map(item => `<div class="cart-line"><img src="${escapeHtml(item.image || '')}" alt=""><div><strong>${escapeHtml(item.product_title)}</strong><p>${item.quantity} × ${money.format(item.final_price / 100)}</p>${cartItemMeta(item)}<button class="remove" type="button" data-cart-remove="${escapeHtml(item.key)}">Remove</button></div><strong>${money.format(item.final_line_price / 100)}</strong></div>`).join('') : '<p class="empty">Your cart is empty.</p>'; if (total) total.textContent = money.format(cart.total_price / 100); }
  async function addVariant(id, quantity = 1) { const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity }] }) }); if (!response.ok) throw new Error('Unable to add this item.'); const cart = await getCart(); updateCount(cart.item_count); toast('Added to cart'); openCart(); }
  document.addEventListener('click', async event => {
    const mediaSwap = event.target.closest('[data-product-media-swap]');
    if (mediaSwap && window.matchMedia('(hover: none), (pointer: coarse)').matches && !mediaSwap.classList.contains('is-alternate')) {
      event.preventDefault();
      document.querySelectorAll('[data-product-media-swap].is-alternate').forEach(tile => tile.classList.remove('is-alternate'));
      mediaSwap.classList.add('is-alternate');
      return;
    }
    const quick = event.target.closest('[data-quick-add]'); if (quick) { quick.disabled = true; try { await addVariant(Number(quick.dataset.quickAdd)); } catch (error) { toast(error.message); } finally { quick.disabled = false; } return; }
    if (event.target.closest('[data-cart-open]')) openCart();
    if (event.target.closest('[data-cart-close]') || event.target === overlay) closeCart();
    const remove = event.target.closest('[data-cart-remove]'); if (remove) { await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: remove.dataset.cartRemove, quantity: 0 }) }); renderCart(); }
    const arrow = event.target.closest('[data-rail]'); if (arrow) { const rail = document.querySelector('#coffeeRail'); rail?.scrollBy({ left: (arrow.dataset.rail === 'next' ? 1 : -1) * Math.max(280, rail.clientWidth * .72), behavior: 'smooth' }); }
    const menu = event.target.closest('[data-menu-toggle]');
    if (menu) {
      const nav = document.querySelector('[data-mobile-menu]');
      if (nav) {
        const open = !nav.classList.contains('open');
        nav.classList.toggle('open', open);
        nav.setAttribute('aria-hidden', String(!open));
        document.querySelectorAll('[data-menu-toggle]').forEach(button => {
          button.setAttribute('aria-expanded', String(open));
        });
        document.body.classList.toggle('no-scroll', open);
      }
      return;
    }
    const menuLink = event.target.closest('[data-mobile-menu] a');
    if (menuLink) {
      const nav = document.querySelector('[data-mobile-menu]');
      nav?.classList.remove('open');
      nav?.setAttribute('aria-hidden', 'true');
      document.querySelectorAll('[data-menu-toggle]').forEach(button => {
        button.setAttribute('aria-expanded', 'false');
      });
      document.body.classList.remove('no-scroll');
    }
  });
  document.addEventListener('submit', async event => { const form = event.target.closest('form[action*="/cart/add"]'); if (!form) return; event.preventDefault(); const data = new FormData(form); const button = form.querySelector('[type="submit"]'); button.disabled = true; try { await addVariant(Number(data.get('id')), Number(data.get('quantity') || 1)); } catch (error) { toast(error.message); } finally { button.disabled = false; } });

  // WCAG relative luminance chooses a neutral gray that clears AAA (7:1)
  // against the dominant flavor circle. It avoids both noisy note colors and
  // unnecessarily harsh pure black/white when a softer gray is still legible.
  const linearChannel = value => {
    const channel = value / 255;
    return channel <= .04045 ? channel / 12.92 : ((channel + .055) / 1.055) ** 2.4;
  };
  const encodedGray = luminance => {
    const channel = luminance <= .0031308 ? luminance * 12.92 : 1.055 * (luminance ** (1 / 2.4)) - .055;
    return Math.max(0, Math.min(255, Math.round(channel * 255)));
  };
  const readableNeutral = hex => {
    const normalized = String(hex || '').trim().replace('#', '');
    const value = normalized.length === 3 ? normalized.split('').map(char => char + char).join('') : normalized;
    if (!/^[0-9a-f]{6}$/i.test(value)) return '#111111';
    const red8 = parseInt(value.slice(0, 2), 16);
    const green8 = parseInt(value.slice(2, 4), 16);
    const blue8 = parseInt(value.slice(4, 6), 16);
    const red = linearChannel(red8);
    const green = linearChannel(green8);
    const blue = linearChannel(blue8);
    const background = .2126 * red + .7152 * green + .0722 * blue;
    const blackContrast = (background + .05) / .05;
    const whiteContrast = 1.05 / (background + .05);
    const maxChannel = Math.max(red8, green8, blue8);
    const saturation = maxChannel ? (maxChannel - Math.min(red8, green8, blue8)) / maxChannel : 0;
    const target = 7 + saturation * .5;
    let gray;
    if (blackContrast >= whiteContrast) {
      if (blackContrast < target) return whiteContrast > blackContrast ? '#f7f7f5' : '#090909';
      gray = encodedGray(Math.max(0, (background + .05) / target - .05));
    } else {
      if (whiteContrast < target) return blackContrast > whiteContrast ? '#090909' : '#f7f7f5';
      gray = encodedGray(Math.min(1, target * (background + .05) - .05));
    }
    const channel = gray.toString(16).padStart(2, '0');
    return `#${channel}${channel}${channel}`;
  };
  document.querySelectorAll('[data-flavor-contrast]').forEach(note => {
    note.style.setProperty('--flavor-ink', readableNeutral(note.dataset.flavorBackground));
  });
  document.querySelectorAll('[data-flavor-button]').forEach(button => {
    button.style.setProperty('--button-ink', readableNeutral(button.dataset.flavorBackground));
  });
  document.querySelectorAll('[data-hover-motif]').forEach(node => {
    const source = node.dataset.noteOne || getComputedStyle(node).getPropertyValue('--note-one') || getComputedStyle(node).getPropertyValue('--tile-accent');
    node.style.setProperty('--motif-ink', readableNeutral(source));
  });

  // Turn the main tasting-note color into a stronger botanical ink. The hue
  // stays recognisably related to the coffee, while saturation and lightness
  // are normalised so pale yellows, dark berries and muted greens all remain
  // visible over the neutral tile background.
  const parseHexColor = hex => {
    const normalized = String(hex || '').trim().replace('#', '');
    const value = normalized.length === 3 ? normalized.split('').map(char => char + char).join('') : normalized;
    if (!/^[0-9a-f]{6}$/i.test(value)) return null;
    return [parseInt(value.slice(0, 2), 16) / 255, parseInt(value.slice(2, 4), 16) / 255, parseInt(value.slice(4, 6), 16) / 255];
  };
  const rgbToHsl = ([red, green, blue]) => {
    const max = Math.max(red, green, blue);
    const min = Math.min(red, green, blue);
    const lightness = (max + min) / 2;
    if (max === min) return [0, 0, lightness];
    const delta = max - min;
    const saturation = lightness > .5 ? delta / (2 - max - min) : delta / (max + min);
    let hue;
    if (max === red) hue = ((green - blue) / delta + (green < blue ? 6 : 0)) / 6;
    else if (max === green) hue = ((blue - red) / delta + 2) / 6;
    else hue = ((red - green) / delta + 4) / 6;
    return [hue, saturation, lightness];
  };
  const hueToRgb = (p, q, value) => {
    let hue = value;
    if (hue < 0) hue += 1;
    if (hue > 1) hue -= 1;
    if (hue < 1 / 6) return p + (q - p) * 6 * hue;
    if (hue < 1 / 2) return q;
    if (hue < 2 / 3) return p + (q - p) * (2 / 3 - hue) * 6;
    return p;
  };
  const hslToHex = ([hue, saturation, lightness]) => {
    let red;
    let green;
    let blue;
    if (saturation === 0) red = green = blue = lightness;
    else {
      const q = lightness < .5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
      const p = 2 * lightness - q;
      red = hueToRgb(p, q, hue + 1 / 3);
      green = hueToRgb(p, q, hue);
      blue = hueToRgb(p, q, hue - 1 / 3);
    }
    return `#${[red, green, blue].map(channel => Math.round(channel * 255).toString(16).padStart(2, '0')).join('')}`;
  };
  const flavorArtTreatment = hex => {
    const rgb = parseHexColor(hex);
    if (!rgb) return { deepInk: '#4c273f', lightInk: '#d4abc9', opacity: .56, darkMain: false };
    const [hue, saturation, lightness] = rgbToHsl(rgb);
    const inkSaturation = Math.max(.38, Math.min(.74, saturation * 1.08 + .16));
    const inkLightness = lightness >= .68 ? .27 : lightness >= .48 ? .29 : lightness >= .28 ? .31 : .34;
    const lightSaturation = Math.max(.32, Math.min(.62, saturation * .72 + .18));
    const relativeLuminance = .2126 * linearChannel(Math.round(rgb[0] * 255)) + .7152 * linearChannel(Math.round(rgb[1] * 255)) + .0722 * linearChannel(Math.round(rgb[2] * 255));
    const opacity = Math.max(.49, Math.min(.62, .49 + (1 - saturation) * .09 + (lightness < .3 ? .045 : 0)));
    return {
      deepInk: hslToHex([hue, inkSaturation, inkLightness]),
      lightInk: hslToHex([hue, lightSaturation, .72]),
      opacity,
      darkMain: relativeLuminance < .10 || lightness < .28
    };
  };
  document.querySelectorAll('[data-flavor-art]').forEach(art => {
    const treatment = flavorArtTreatment(art.dataset.flavorBackground);
    const isLeft = art.classList.contains('flavor-art-left');
    const useLightInk = isLeft && treatment.darkMain;
    art.style.setProperty('--flavor-art-ink', useLightInk ? treatment.lightInk : treatment.deepInk);
    art.style.setProperty('--flavor-art-blend', useLightInk ? 'screen' : 'multiply');
    art.style.setProperty('--flavor-art-opacity', (useLightInk ? .43 : treatment.opacity).toFixed(3));
  });

  const setupProductRailMotion = () => {
    const rail = document.querySelector('#coffeeRail');
    if (!rail || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const cards = [...rail.querySelectorAll('.home-product-card')];
    let frame = 0;
    const update = () => {
      frame = 0;
      const railCenter = rail.scrollLeft + rail.clientWidth / 2;
      const radius = Math.max(rail.clientWidth * .56, 1);
      cards.forEach(card => {
        const cardCenter = card.offsetLeft + card.offsetWidth / 2;
        const focus = Math.max(0, 1 - Math.abs(cardCenter - railCenter) / radius);
        card.style.setProperty('--rail-focus', focus.toFixed(3));
        card.style.setProperty('--rail-image-scale', (1 + focus * .012).toFixed(4));
        card.style.setProperty('--rail-shadow-y', `${(4 + focus * 4).toFixed(2)}px`);
        card.style.setProperty('--rail-shadow-blur', `${(12 + focus * 10).toFixed(2)}px`);
        card.style.setProperty('--rail-shadow-alpha', (.035 + focus * .035).toFixed(3));
      });
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    rail.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    requestAnimationFrame(update);
  };


  const setupHomePeony = () => {
    const peony = document.querySelector('[data-home-peony]');
    if (!peony) return;

    const sources = String(peony.dataset.peonySources || '')
      .split('||')
      .map(source => source.trim())
      .filter(Boolean);
    if (sources.length < 2) return;

    const storageKey = 'senseiHomePeonyQueueV2';
    const lastKey = 'senseiHomePeonyLastV2';
    let queue = [];

    try {
      const stored = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
      if (Array.isArray(stored)) queue = stored.filter(index => Number.isInteger(index) && index >= 0 && index < sources.length);
    } catch (error) {
      queue = [];
    }

    if (!queue.length) {
      queue = Array.from({ length: sources.length }, (_, index) => index);
      for (let index = queue.length - 1; index > 0; index -= 1) {
        const swapIndex = Math.floor(Math.random() * (index + 1));
        [queue[index], queue[swapIndex]] = [queue[swapIndex], queue[index]];
      }
      const last = Number(sessionStorage.getItem(lastKey));
      if (Number.isInteger(last) && queue[queue.length - 1] === last && queue.length > 1) {
        [queue[queue.length - 1], queue[queue.length - 2]] = [queue[queue.length - 2], queue[queue.length - 1]];
      }
    }

    const selected = queue.pop();
    peony.src = sources[selected];
    try {
      sessionStorage.setItem(storageKey, JSON.stringify(queue));
      sessionStorage.setItem(lastKey, String(selected));
    } catch (error) {
      // The visual still works when session storage is unavailable.
    }
  };
  setupHomePeony();


  const setupWholesaleForm = () => {
    const form = document.querySelector('#WholesaleForm.wholesale-form');
    if (!form) return;

    form.classList.add('is-enhanced');
    form.dataset.wholesaleStep = '0';

    const tabs = [...form.querySelectorAll('[data-wholesale-go-step]')];
    const status = form.querySelector('[data-wholesale-current-step]');
    const requiredFields = [...form.querySelectorAll('[data-wholesale-step="0"] input[required], [data-wholesale-step="0"] select[required], [data-wholesale-step="0"] textarea[required]')];

    const setStep = step => {
      const nextStep = String(step === 1 || step === '1' ? 1 : 0);
      form.dataset.wholesaleStep = nextStep;
      tabs.forEach(tab => {
        const active = tab.dataset.wholesaleGoStep === nextStep;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
      });
      if (status) status.textContent = nextStep === '0' ? 'Required' : 'Optional';
    };

    const firstInvalidRequiredField = () => requiredFields.find(field => !field.checkValidity());

    form.querySelectorAll('[data-wholesale-next]').forEach(button => {
      button.addEventListener('click', () => {
        const invalid = firstInvalidRequiredField();
        if (invalid) {
          invalid.reportValidity();
          invalid.focus({ preventScroll: false });
          return;
        }
        setStep(1);
      });
    });

    form.querySelectorAll('[data-wholesale-prev]').forEach(button => {
      button.addEventListener('click', () => setStep(0));
    });

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        if (tab.dataset.wholesaleGoStep === '1') {
          const invalid = firstInvalidRequiredField();
          if (invalid) {
            invalid.reportValidity();
            invalid.focus({ preventScroll: false });
            return;
          }
        }
        setStep(tab.dataset.wholesaleGoStep);
      });
    });

    form.addEventListener('submit', event => {
      const invalid = firstInvalidRequiredField();
      if (invalid) {
        event.preventDefault();
        setStep(0);
        invalid.reportValidity();
        invalid.focus({ preventScroll: false });
      }
    });
  };
  setupWholesaleForm();



  const setupAboutStory = () => {
    const root = document.querySelector('[data-about-story]');
    if (!root) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const reveals = [...root.querySelectorAll('.about-reveal')];
    reveals.forEach(el => el.style.setProperty('--about-delay', el.dataset.delay || '0'));

    if (!('IntersectionObserver' in window) || reducedMotion) {
      reveals.forEach(el => el.classList.add('is-visible'));
    } else {
      const revealObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      }, { threshold: .14, rootMargin: '0px 0px -9% 0px' });
      reveals.forEach(el => revealObserver.observe(el));
    }

    const scenes = [...root.querySelectorAll('[data-about-scene]')];
    if ('IntersectionObserver' in window) {
      const sceneObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          entry.target.classList.toggle('is-active', entry.isIntersecting);
          if (entry.isIntersecting && ['principles','questions','closing'].includes(entry.target.dataset.aboutScene)) {
            root.style.setProperty('--about-light-opacity', entry.target.dataset.aboutScene === 'closing' ? '.87' : '.82');
          } else if (entry.isIntersecting) {
            root.style.setProperty('--about-light-opacity', '.74');
          }
        });
      }, { threshold: .3 });
      scenes.forEach(scene => sceneObserver.observe(scene));
    }

    if (!reducedMotion && window.matchMedia('(min-width: 901px)').matches) {
      let frame = 0;
      const updateParallax = () => {
        frame = 0;
        const rect = root.getBoundingClientRect();
        const progress = Math.max(0, Math.min(1, -rect.top / Math.max(1, rect.height - window.innerHeight)));
        root.style.setProperty('--about-art-y', `${(progress * 34).toFixed(2)}px`);
        root.style.setProperty('--about-light-y', `${(progress * 76).toFixed(2)}px`);
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(updateParallax); };
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      requestAnimationFrame(updateParallax);
    }
  };
  setupAboutStory();
  const reveal = () => { if (!('IntersectionObserver' in window)) return; const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('visible'); observer.unobserve(entry.target); } }), { threshold: .06 }); document.querySelectorAll('.reveal').forEach(el => observer.observe(el)); };
  reveal();
  // The home rail now uses stable geometry; motion is limited to direct hover/focus feedback.

  // === AB2Q-R5B-5 — APPROVED MOBILE ABOUT INTEGRATION ===
  const setupSenseiAboutR5B = () => {
    const root = document.querySelector('[data-sensei-about-r5b]');
    if (!root || root.dataset.senseiAboutReady === 'true') return;

    root.dataset.senseiAboutReady = 'true';

    const hero = root.querySelector('[data-sensei-about-hero]');
    const shell = root.querySelector('[data-sensei-about-hero-shell]');
    const fx = root.querySelector('[data-sensei-about-fx]');
    const dust = root.querySelector('[data-sensei-about-dust]');
    const story = root.querySelector('[data-sensei-about-story]');
    if (!hero || !shell || !fx || !dust || !story) return;

    /* 1.0.126 — PC ABOUT is intentionally static. All copy remains visible
       during normal document scrolling. The approved mobile branch below is
       untouched and continues to own the mobile hero and reveal behavior. */
    if (window.matchMedia('(min-width: 901px)').matches) {
      const heroCopy = root.querySelector('.sensei-about-r5b__pc-hero-copy-inner');
      const scenes = Array.from(root.querySelectorAll('.sensei-about-r5b__scene'));

      root.classList.add('is-pc-ready');
      if (heroCopy) {
        heroCopy.style.opacity = '1';
        heroCopy.style.transform = 'none';
      }
      hero.style.opacity = '1';
      hero.style.transform = 'none';
      hero.style.pointerEvents = 'auto';

      scenes.forEach(scene => {
        scene.classList.add('is-pc-active', 'is-presented', 'is-atmospheric');
        scene.querySelectorAll('.sensei-about-r5b__reveal').forEach(item => {
          item.classList.add('is-visible');
          item.style.transitionDelay = '0ms';
        });
      });
      return;
    }

    const fctx = fx.getContext('2d');
    const dctx = dust.getContext('2d');
    if (!fctx || !dctx) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const duration = reducedMotion ? 380 : 2550;
    let consumed = false;
    let lightFrame = 0;
    let transitionFrame = 0;
    let storyFrame = 0;
    let particles = [];
    let ratio = 1;

    const ease = t => t < .5 ? 4*t*t*t : 1 - Math.pow(-2*t + 2, 3) / 2;
    const clamp = value => Math.max(0, Math.min(1, value));
    const smoothBell = t => {
      const up = ease(Math.min(1, t / .58));
      const down = 1 - ease(Math.max(0, (t - .58) / .42));
      return t <= .58 ? up : down;
    };

    const setCanvas = canvas => {
      const rect = hero.getBoundingClientRect();
      ratio = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(rect.width * ratio);
      canvas.height = Math.round(rect.height * ratio);
      canvas.style.width = `${rect.width}px`;
      canvas.style.height = `${rect.height}px`;
    };

    const seededRandom = seed => () => {
      seed |= 0;
      seed = seed + 0x6D2B79F5 | 0;
      let t = Math.imul(seed ^ seed >>> 15, 1 | seed);
      t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
      return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };

    const buildParticles = () => {
      const rect = hero.getBoundingClientRect();
      const random = seededRandom(2407);
      const count = Math.max(52, Math.round(rect.width * .18));
      particles = Array.from({ length: count }, () => ({
        x: rect.width * (.06 + random() * .54),
        y: rect.height * (.03 + random() * .62),
        r: .5 + random() * 1.6,
        a: .04 + random() * .14,
        dx: -2 + random() * 4,
        dy: -6 + random() * 10,
        phase: random() * Math.PI * 2
      }));
    };

    const resizeCanvas = () => {
      setCanvas(fx);
      setCanvas(dust);
      fctx.setTransform(ratio, 0, 0, ratio, 0, 0);
      dctx.setTransform(ratio, 0, 0, ratio, 0, 0);
      buildParticles();
      drawLight(0);
      drawDust(0, 0);
    };

    const drawSoftShape = (ctx, x, y, rx, ry, rotation, alpha, stops) => {
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(rotation);
      ctx.scale(rx, ry);
      const gradient = ctx.createRadialGradient(0, 0, 0, 0, 0, 1);
      stops.forEach(stop => gradient.addColorStop(
        stop[0],
        `rgba(${stop[1]}, ${stop[2]}, ${stop[3]}, ${(stop[4] * alpha).toFixed(4)})`
      ));
      ctx.fillStyle = gradient;
      ctx.beginPath();
      ctx.arc(0, 0, 1, 0, Math.PI * 2);
      ctx.fill();
      ctx.restore();
    };

    function drawLight(progress) {
      const rect = hero.getBoundingClientRect();
      const width = rect.width;
      const height = rect.height;
      const strength = smoothBell(progress);
      fctx.clearRect(0, 0, width, height);
      if (strength <= .001) return;

      const driftX = width * (.015 * Math.sin(progress * Math.PI * 1.1));
      const driftY = height * (.012 * Math.sin(progress * Math.PI * .9));

      drawSoftShape(fctx, width * .29 + driftX, height * .14 + driftY, width * .42, height * .31, -.55, .72 * strength, [
        [0, 246, 243, 250, .22], [.25, 220, 212, 235, .18], [.52, 170, 150, 206, .08], [.82, 120, 103, 164, .025], [1, 120, 103, 164, 0]
      ]);
      drawSoftShape(fctx, width * .40 + driftX * .6, height * .30 + driftY * .7, width * .34, height * .26, -.42, .58 * strength, [
        [0, 242, 238, 247, .13], [.34, 203, 191, 224, .10], [.68, 145, 127, 185, .04], [1, 145, 127, 185, 0]
      ]);
      drawSoftShape(fctx, width * .33 + driftX * .35, height * .38 + driftY * .2, width * .18, height * .11, -.15, .64 * strength, [
        [0, 252, 248, 246, .15], [.42, 223, 213, 234, .09], [.74, 164, 143, 200, .03], [1, 164, 143, 200, 0]
      ]);

      fctx.save();
      const guard = fctx.createRadialGradient(width * .49, height * .44, 0, width * .49, height * .44, width * .15);
      guard.addColorStop(0, `rgba(4,5,11,${(.12 * strength).toFixed(4)})`);
      guard.addColorStop(.45, `rgba(4,5,11,${(.07 * strength).toFixed(4)})`);
      guard.addColorStop(1, 'rgba(4,5,11,0)');
      fctx.globalCompositeOperation = 'multiply';
      fctx.fillStyle = guard;
      fctx.fillRect(0, 0, width, height);
      fctx.restore();
    }

    function drawDust(progress, elapsed) {
      const rect = hero.getBoundingClientRect();
      const width = rect.width;
      const height = rect.height;
      const strength = smoothBell(progress);
      dctx.clearRect(0, 0, width, height);
      if (strength <= .001) return;

      dctx.save();
      dctx.globalCompositeOperation = 'screen';
      particles.forEach(particle => {
        const wobble = Math.sin(elapsed * .0016 + particle.phase) * 2.6;
        const x = particle.x + particle.dx * progress * 4 + wobble * .25;
        const y = particle.y + particle.dy * progress * 1.8;
        const xMask = Math.max(0, 1 - Math.abs(x - width * .30) / (width * .34));
        const yMask = Math.max(0, 1 - Math.abs(y - height * .28) / (height * .40));
        const alpha = particle.a * strength * xMask * yMask;
        if (alpha < .004) return;
        dctx.beginPath();
        dctx.fillStyle = `rgba(238,232,244,${alpha.toFixed(4)})`;
        dctx.shadowColor = `rgba(223,214,238,${(alpha * .9).toFixed(4)})`;
        dctx.shadowBlur = particle.r * 4.6;
        dctx.arc(x, y, particle.r, 0, Math.PI * 2);
        dctx.fill();
      });
      dctx.restore();
    }

    const finishLight = () => {
      hero.classList.remove('is-playing');
      hero.dataset.state = 'complete';
      cancelAnimationFrame(lightFrame);
      drawLight(0);
      drawDust(0, 0);
    };

    const animateLight = (start, now) => {
      const elapsed = now - start;
      const progress = Math.min(1, elapsed / duration);
      drawLight(progress);
      drawDust(progress, elapsed);
      if (progress < 1) {
        lightFrame = requestAnimationFrame(time => animateLight(start, time));
      } else {
        finishLight();
      }
    };

    const triggerLight = () => {
      if (consumed) return;
      consumed = true;
      hero.dataset.state = 'playing';
      hero.classList.add('is-playing');
      cancelAnimationFrame(lightFrame);
      lightFrame = requestAnimationFrame(time => animateLight(time, time));
    };

    const updateHeroTransition = () => {
      transitionFrame = 0;
      const range = Math.max(1, shell.offsetHeight - hero.offsetHeight);
      const progress = clamp(-shell.getBoundingClientRect().top / range);
      const fadeProgress = clamp((progress - .12) / .48);
      const fade = ease(fadeProgress);
      hero.style.opacity = String(1 - fade);
      hero.style.transform = `translate3d(0, ${(-3 * fade).toFixed(3)}svh, 0)`;
      hero.style.pointerEvents = fade > .985 ? 'none' : 'auto';
      hero.dataset.scrollProgress = progress.toFixed(3);

      /* The first story block is reversible. It appears only after the hero
         has disappeared, then hides again before the hero becomes visible on
         reverse scroll. Hysteresis prevents flicker around the threshold. */
      if (fade >= .985) {
        setFirstSceneVisible(true);
      } else if (fade <= .90) {
        setFirstSceneVisible(false);
      }
    };

    const requestHeroTransition = () => {
      if (transitionFrame) return;
      transitionFrame = requestAnimationFrame(updateHeroTransition);
    };

    const scenes = Array.from(root.querySelectorAll('.sensei-about-r5b__scene'));
    const firstScene = scenes[0] || null;
    const shown = new Set();
    scenes.forEach((scene, sceneIndex) => {
      scene.dataset.compactScene = String(sceneIndex);
      const items = Array.from(scene.querySelectorAll('.sensei-about-r5b__reveal'));
      items.forEach((item, itemIndex) => {
        item.dataset.sequence = `${sceneIndex}-${itemIndex}`;
        item.style.transitionDelay = `${Math.min(itemIndex * 85, 340)}ms`;
      });
    });

    const setFirstSceneVisible = visible => {
      if (!firstScene) return;
      firstScene.classList.toggle('is-presented', visible);
      firstScene.classList.toggle('is-atmospheric', visible);
      firstScene.querySelectorAll('.sensei-about-r5b__reveal').forEach(item => {
        item.classList.toggle('is-visible', visible);
      });
      if (visible) shown.add(firstScene);
      else shown.delete(firstScene);
    };

    const revealScene = scene => {
      if (!scene || shown.has(scene)) return;
      if (scene === firstScene) {
        setFirstSceneVisible(true);
        return;
      }
      shown.add(scene);
      scene.classList.add('is-presented', 'is-atmospheric');
      requestAnimationFrame(() => {
        scene.querySelectorAll('.sensei-about-r5b__reveal').forEach(item => item.classList.add('is-visible'));
      });
    };

    const updateStory = () => {
      storyFrame = 0;
      const viewportHeight = Math.max(1, window.innerHeight);
      const chromeHeight = parseFloat(getComputedStyle(root).getPropertyValue('--chrome-h')) || 92;
      const rootTop = root.getBoundingClientRect().top + window.scrollY;
      const relativeScroll = Math.max(0, window.scrollY - rootTop);
      const firstTrigger = Math.max(16, viewportHeight * .15);

      scenes.forEach((scene, index) => {
        if (shown.has(scene)) return;
        const rect = scene.getBoundingClientRect();
        if (index === 0) {
          /* First scene is controlled exclusively by hero fade completion. */
          return;
        }
        const triggerLine = chromeHeight + (viewportHeight - chromeHeight) * .82;
        if (rect.top <= triggerLine && rect.bottom > chromeHeight) revealScene(scene);
      });
    };

    const requestStoryUpdate = () => {
      if (storyFrame) return;
      storyFrame = requestAnimationFrame(updateStory);
    };

    if (reducedMotion) scenes.forEach(revealScene);

    resizeCanvas();
    updateHeroTransition();
    requestStoryUpdate();
    hero.addEventListener('pointerdown', triggerLight, { passive: true });
    hero.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') triggerLight();
    });
    window.addEventListener('scroll', requestHeroTransition, { passive: true });
    window.addEventListener('scroll', requestStoryUpdate, { passive: true });
    window.addEventListener('resize', () => {
      resizeCanvas();
      requestHeroTransition();
      requestStoryUpdate();
    }, { passive: true });
  };

  setupSenseiAboutR5B();
})();
